export const permissionList = {
	ManagerReviewApplication: "ManagerReviewApplication",
	RiskTickets: "RiskTickets",
	ReassignRiskTickets: "ReassignRiskTickets",
	PeriodicCreditReview: "PeriodicCreditReview",
	RiskThresholdAdjustment: "RiskThresholdAdjustment",
	Boarding: "Boarding",
	EquipmentOrdering: "EquipmentOrdering",
	EquipmentBilling: "EquipmentBilling",
	DeploymentSoftwareIntegration: "DeploymentSoftwareIntegration",
	BankChange: "BankChange",
	ViewSensitiveAccountDataPartial: "ViewSensitiveAccountDataPartial",
	ViewSensitiveAccountDataFull: "ViewSensitiveAccountDataFull",
	ViewLevel1: "ViewLevel1",
	ViewLevel2: "ViewLevel2",
	ViewLevel3: "ViewLevel3",
	ViewLevel4: "ViewLevel4",
	ViewBatchHistory: "ViewBatchHistory",
	ViewDepositHistory: "ViewDepositHistory",
	ViewStatements: "ViewStatements",
	ViewChargebacks: "ViewChargebacks",
	ViewRetrievals: "ViewRetrievals",
	ViewAuthorizations: "ViewAuthorizations",
	AddAccountNotes: "AddAccountNotes",
	ViewAccountNotes: "ViewAccountNotes",
	ViewPrivateNotesUwOnly: "ViewPrivateNotesRiskUwOnly",
	ViewPrivateNotesManagersOnly: "ViewPrivateNotesManagersOnly",
	ViewPrivateNotesEmployeesOnly: "ViewPrivateNotesEmployeesOnly",
	DeleteAccountNotes: "DeleteAccountNotes",
	AddUserInternalSalesAgent: "AddUser(InternalSalesAgent)",
	AddUserOps: "AddUser(Ops)",
	AddUserExternalAgentPartner: "AddUser(ExternalAgent/Partner)",
	AddUserHtOps: "AddUser(HtOps)",
	AddUserFinance: "AddUserFinance",
	ManualMerchantEntry: "ManualMerchantEntry",
	ManageAgentOffice: "ManageAgentOffice",
	ReviewPreviousCredit: "ReviewPreviousCredit",
	SetUpMerchantLevelUser: "SetUpMerchantLevelUser",
	ViewInProgressApplication: "ViewInProgressApplication",
	QAApplication: "QAApplication",
	StartNewApplication: "StartNewApplication",
	UnderwritingSensitiveCreditInfo: "UnderwritingSensitiveCreditInfo",
	AddTerminalManually: "AddTerminalManually",
	ManageHierarchy: "ManageHierarchy",
	RemoveDraftApplication: "RemoveDraftApplication",
	ViewAllAccountsInAgentOffice: "ViewAllAccountsInAgentOffice",
	ViewAllAccountsDownstream: "ViewAllAccountsDownstream",
	CreateScheduleAOrResidualSplitProfileForAgentOfficeOrAgent:
		"CreateScheduleAOrResidualSplitProfileForAgentOfficeOrAgent",
	EditExistinScheduleAOrResidualSplitProfileForAgentOfficeOrAgent:
		"EditExistinScheduleAOrResidualSplitProfileForAgentOfficeOrAgent",
	ChangeScheduleAOrResidualSplitProfileAllocatedToLiveMerchant:
		"ChangeScheduleAOrResidualSplitProfileAllocatedToLiveMerchant",
	ChangeScheduleAOrResidualSplitProfileAllocatedToAnApplication:
		"ChangeScheduleAOrResidualSplitProfileAllocatedToAnApplication",
	EditResidualsStatus: "EditResidualsStatus",
	EditResidualsPayoutDetails: "EditResidualsPayoutDetails",
	ViewScheduleAsResidualSplitProfilesOfAgentOffice:
		"ViewScheduleAsResidualSplitProfilesOfAgentOffice",
	ViewScheduleAsResidualSplitProfilesDownstream:
		"ViewScheduleAsResidualSplitProfilesDownstream",
	PrimaryAgentViewResidualsDetailsForTheirAccounts:
		"PrimaryAgentViewResidualsDetailsForTheirAccounts",
	RunViewResidualsProcessInRiseFileUploadImportNormalizationCalculationsAdjustmentsPayoutsReporting:
		"RunViewResidualsProcessInRiseFileUploadImportNormalizationCalculationsAdjustmentsPayoutsReporting",
	ViewProposedResidualPayoutsInRise: "ViewProposedResidualPayoutsInRise",
	ApproveProposedResidualPayouts: "ApproveProposedResidualPayouts",
	PrimaryAgentViewTheirResidualsReports:
		"PrimaryAgentViewTheirResidualsReports",
	ViewResidualReportsOfAgentOfficeAndAgentsWithinAgentOffice:
		"ViewResidualReportsOfAgentOfficeAndAgentsWithinAgentOffice",
	ViewAllAgentResidualReports: "ViewAllAgentResidualReports",
	ViewInternalResidualReports: "ViewInternalResidualReports",
	ViewResidualsDataCleanse: "ViewResidualsDataCleanse",
	ViewPrivateResidualSplits: "ViewPrivateResidualSplits",
	WithdrawAttachmentsCreatedByAnyUser: "WithdrawAttachmentsCreatedByAnyUser",
	ChangeAgentOrOfficeOfExistingMerchant:
		"ChangeAgentOrOfficeOfExistingMerchant",
};

export const viewAppPermissionSet = [
	permissionList.ViewInProgressApplication,
	permissionList.QAApplication,
	permissionList.ManagerReviewApplication,
];

export const userPermissionSet = [
	permissionList.AddUserInternalSalesAgent,
	permissionList.AddUserExternalAgentPartner,
	permissionList.AddUserOps,
	permissionList.AddUserHtOps,
	permissionList.AddUserFinance,
];

export const viewBoardingPagePermissionSet = [
	permissionList.EquipmentOrdering,
	permissionList.Boarding,
	permissionList.QAApplication,
];

export const boardingQueuePermissionSet = [
	permissionList.EquipmentOrdering,
	permissionList.Boarding,
];

export const qaQueuePermissionSet = [permissionList.QAApplication];

export const applicationListPermissionSet = [
	permissionList.StartNewApplication,
	permissionList.ViewInProgressApplication,
	permissionList.QAApplication,
	permissionList.ManagerReviewApplication,
];

export const merchantRiskPermissionSet = [
	permissionList.RiskTickets,
	permissionList.ReassignRiskTickets,
	permissionList.RiskThresholdAdjustment,
];

export const notesViewPermissionSet = [permissionList.ViewAccountNotes];

export const notesAddPermissionSet = [permissionList.AddAccountNotes];

export const backOfficeNotesPermissionSet = [
	permissionList.ViewPrivateNotesEmployeesOnly,
	permissionList.ViewPrivateNotesManagersOnly,
	permissionList.ViewPrivateNotesUwOnly,
];

export const attachmentPermissionSet = [
	permissionList.ViewLevel1,
	permissionList.ViewLevel2,
	permissionList.ViewLevel3,
	permissionList.ViewLevel4,
];

export const systemSetupPermissionSet = [
	...userPermissionSet,
	permissionList.SetUpMerchantLevelUser,
	permissionList.ManageAgentOffice,
	permissionList.ManageHierarchy,
];

export const agentPermissionSet = [permissionList.ManageAgentOffice];
export const equipmentOrderingPermissionSet = [
	permissionList.EquipmentOrdering,
];
export const installationPermissionSet = [
	permissionList.DeploymentSoftwareIntegration,
];
export const uwDecisionPermissionSet = [
	permissionList.UnderwritingSensitiveCreditInfo,
	permissionList.ReviewPreviousCredit,
];

export const uwMerchantInfoPermissionSet = [
	permissionList.BankChange,
	permissionList.ViewSensitiveAccountDataFull,
	permissionList.ViewSensitiveAccountDataPartial,
	permissionList.AddAccountNotes,
	...uwDecisionPermissionSet,
];

export const uwFinancialPermissionSet = [
	permissionList.UnderwritingSensitiveCreditInfo,
	permissionList.ReviewPreviousCredit,
	permissionList.AddAccountNotes,
];

export const viewSensitiveDataFullPermissionSet = [
	permissionList.ViewSensitiveAccountDataFull,
];

export const viewSensitiveDataPermissionSet = [
	permissionList.ViewSensitiveAccountDataFull,
	permissionList.ViewSensitiveAccountDataPartial,
];

export const underwritingQueuePermissionSet = [...uwDecisionPermissionSet];

export const underwritingDetailPagePermissionSet = [...uwDecisionPermissionSet];

export const underwritingPagePermissionSet = [...uwDecisionPermissionSet];

export const merchantPermissionSet = [
	permissionList.ViewChargebacks,
	permissionList.ViewBatchHistory,
	permissionList.ViewDepositHistory,
	permissionList.ViewStatements,
	permissionList.ManualMerchantEntry,
	...merchantRiskPermissionSet,
	...notesViewPermissionSet,
];

export const editMerchantPermissionSet = [permissionList.ManualMerchantEntry];

export const creditReviewPermissionSet = [permissionList.PeriodicCreditReview];

export const runViewResidualsProcessSet = [
	permissionList.RunViewResidualsProcessInRiseFileUploadImportNormalizationCalculationsAdjustmentsPayoutsReporting,
];
export const viewScheduleAOrResidualSplitsPermissionSet = [
	permissionList.ViewScheduleAsResidualSplitProfilesOfAgentOffice,
	permissionList.ViewScheduleAsResidualSplitProfilesDownstream,
];

export const viewResidualsDataCleanseSet = [
	permissionList.ViewResidualsDataCleanse,
	...runViewResidualsProcessSet,
];

export const viewResidualsPaymentsSet = [
	permissionList.ViewProposedResidualPayoutsInRise,
	permissionList.ApproveProposedResidualPayouts,
	...runViewResidualsProcessSet,
];

export const viewAgentOfficeResidualsReportsSet = [
	permissionList.RunViewResidualsProcessInRiseFileUploadImportNormalizationCalculationsAdjustmentsPayoutsReporting,
	permissionList.ViewResidualReportsOfAgentOfficeAndAgentsWithinAgentOffice,
	permissionList.ViewAllAgentResidualReports,
];

export const viewAgentResidualsReportsSet = [
	permissionList.RunViewResidualsProcessInRiseFileUploadImportNormalizationCalculationsAdjustmentsPayoutsReporting,
	permissionList.PrimaryAgentViewTheirResidualsReports,
	permissionList.ViewResidualReportsOfAgentOfficeAndAgentsWithinAgentOffice,
	permissionList.ViewAllAgentResidualReports,
];

export const viewInternalResidualsReportsSet = [
	permissionList.RunViewResidualsProcessInRiseFileUploadImportNormalizationCalculationsAdjustmentsPayoutsReporting,
	permissionList.ViewInternalResidualReports,
];

export const viewResidualsReportsSet = [
	...viewAgentResidualsReportsSet,
	...viewAgentOfficeResidualsReportsSet,
	...viewInternalResidualsReportsSet,
];

export const viewResidualsTabSet = [
	...runViewResidualsProcessSet,
	...viewResidualsDataCleanseSet,
	...viewResidualsPaymentsSet,
	...viewResidualsReportsSet,
];

export const editResidualsStatusSet = [permissionList.EditResidualsStatus];
export const editAgentResidualsStatusPermissionSet = [
	permissionList.ManageAgentOffice,
	permissionList.EditResidualsStatus,
];
export const editResidualsPayoutDetailsSet = [
	permissionList.EditResidualsPayoutDetails,
];

export const editTerminalPageSet = [
	permissionList.EquipmentOrdering,
	permissionList.DeploymentSoftwareIntegration,
	permissionList.AddTerminalManually,
];

export const viewHistoryScheduleASet = [
	permissionList.CreateScheduleAOrResidualSplitProfileForAgentOfficeOrAgent,
	permissionList.EditExistinScheduleAOrResidualSplitProfileForAgentOfficeOrAgent,
];

export const terminalSolutionPermissionSet = [
	...merchantPermissionSet,
	permissionList.EquipmentBilling,
];

export const residualsUserPermissionSet = [
	permissionList.AddUserInternalSalesAgent,
	permissionList.AddUserOps,
	permissionList.AddUserExternalAgentPartner,
];

export const zendeskTicketsPermissionSet = [
	permissionList.ManageAgentOffice,
	permissionList.AddUserExternalAgentPartner,
	permissionList.ViewAllAccountsInAgentOffice,
	permissionList.ViewAllAccountsDownstream,
];
